// extracted by mini-css-extract-plugin
export default {"container":"PageHeaderWOB_container__K2+QK","block":"PageHeaderWOB_block__5MyBm"};